import { Component, NgZone } from "@angular/core";
import {
  SegmentButton,
  App,
  NavParams,
  NavController,
  LoadingController,
  AlertController
} from "ionic-angular";
import { SettingsPage } from "../settings/settings";
import { ProfileModel } from "./profile.model";
import { ProfileService } from "./profile.service";
import { AngularFireDatabase } from "angularfire2/database";
import firebase from "firebase";

import { UserProvider } from "../../providers/user/user";

import "rxjs/Rx";
import { ToastProvider } from "../../providers/toast/toast";

@Component({
  selector: "profile-page",
  templateUrl: "profile.html"
})
export class ProfilePage {
  display: string;
  user: any;
  displayName: string;
  theme: string;
  avatar: string;
  scanCount: number = 0;
  addCount: number = 0;
  status: boolean = false;
  transactions: string[] = [];
  referrals: string[] = [];
  refUsed: string = "";
  constructor(
    public database: AngularFireDatabase,
    public userservice: UserProvider,
    public zone: NgZone,
    public navCtrl: NavController,
    public app: App,
    public navParams: NavParams,
    public profileService: ProfileService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public toast: ToastProvider
  ) {
    this.display = "tab1";
    this.loaduserdetails();
  }

  public lineChartData: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: "Series A" },
    { data: [28, 48, 40, 19, 86, 27, 90], label: "Series B" },
    { data: [18, 48, 77, 9, 100, 27, 40], label: "Series C" }
  ];
  public lineChartLabels: Array<any> = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July"
  ];
  public lineChartOptions: any = {
    responsive: true
  };
  public lineChartColors: Array<any> = [
    {
      // grey
      backgroundColor: "rgba(148,159,177,0.2)",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // dark grey
      backgroundColor: "rgba(77,83,96,0.2)",
      borderColor: "rgba(77,83,96,1)",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,83,96,1)"
    },
    {
      // grey
      backgroundColor: "rgba(148,159,177,0.2)",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    }
  ];
  public lineChartLegend: boolean = true;
  public lineChartType: string = "line";

  public randomize(): void {
    let _lineChartData: Array<any> = new Array(this.lineChartData.length);
    for (let i = 0; i < this.lineChartData.length; i++) {
      _lineChartData[i] = {
        data: new Array(this.lineChartData[i].data.length),
        label: this.lineChartData[i].label
      };
      for (let j = 0; j < this.lineChartData[i].data.length; j++) {
        _lineChartData[i].data[j] = Math.floor(Math.random() * 100 + 1);
      }
    }
    this.lineChartData = _lineChartData;
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  ionViewWillEnter() {
    this.loaduserdetailswithoutloader();
  }

  ionViewDidLeave() {
    this.loaduserdetailswithoutloader();
  }

  viewScannedBlocks() {
    this.navCtrl.push("ViewscannedPage", { user: this.user });
  }

  viewAddedBlocks() {
    this.navCtrl.push("ViewaddedPage", { user: this.user });
  }

  getVerified() {
    if (!this.user.appliedForVerification) {
      let alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        title: "Not Verified!",
        message:
          "In order to add items to our platform, you must be verified by our staff.",
        buttons: [
          {
            text: "Dismiss",
            role: "cancel",
            handler: () => {}
          },
          {
            text: "Get Verified!",
            handler: () => {
              this.navCtrl.push("GetverifiedPage", { user: this.user });
            }
          }
        ]
      });
      alert.present();
    } else if (this.user.appliedForVerification) {
      let alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        title: "Application Received Already",
        message: "We are still reviewing your application.",
        buttons: [
          {
            text: "Dismiss",
            role: "cancel",
            handler: () => {}
          }
        ]
      });
      alert.present();
    }
  }

  public doughnutChartLabels: string[] = ["Items Added", "Items Scanned"];
  public doughnutChartData: number[] = [0, 0];
  public doughnutChartType: string = "doughnut";

  loaduserdetails() {
    this.userservice.getuserdetails().then((res: any) => {
      this.displayName = res.displayName;
      this.user = res;
      this.addCount = this.user.addedItemCount;
      if (this.user.referrals[0] != "None") {
        this.referrals = this.user.referrals;
      }
      this.scanCount = this.user.scannedItemCount;
      this.doughnutChartData = [this.addCount, this.scanCount];
      if (this.user.transactions[0] != "0") {
        this.transactions = this.user.transactions;
        this.transactions.reverse();
      }
      if (this.user.verifiedManufacturer) {
        this.status = true;
      }
      this.zone.run(() => {
        this.avatar = res.photoURL;
      });
    });
  }

  loaduserdetailswithoutloader() {
    this.userservice.getuserdetails().then((res: any) => {
      this.displayName = res.displayName;
      this.user = res;
      this.addCount = this.user.addedItemCount;
      this.scanCount = this.user.scannedItemCount;
      this.doughnutChartData = [this.addCount, this.scanCount];
      if (this.user.referralCodeUsed != "None") {
        this.refUsed = this.user.referralCodeUsed;
      }
      if (this.user.referrals[0] != "None") {
        this.referrals = this.user.referrals;
      }
      if (this.user.transactions[0] != "0") {
        this.transactions = this.user.transactions;
        this.transactions.reverse();
      }
      if (this.user.verifiedManufacturer) {
        this.status = true;
      }
      this.zone.run(() => {
        this.avatar = res.photoURL;
      });
    });
  }

  openTransaction(transaction) {
    if (transaction.indexOf("Add") > -1) {
      this.toast.show(
        "Added item on " + transaction.slice(0, transaction.indexOf("T"))
      );
    } else if (transaction.indexOf("Scan") > -1) {
      this.toast.show(
        "Scanned item on " + transaction.slice(0, transaction.indexOf("T"))
      );
    }
  }

  goToSettings() {
    this.navCtrl.push(SettingsPage, {
      name: this.displayName,
      avatar: this.avatar,
      user: this.user,
      theme: this.theme
    });
  }

  onSegmentChanged(segmentButton: SegmentButton) {}

  onSegmentSelected(segmentButton: SegmentButton) {}
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts